import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Menu, Tooltip } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import TextFieldForObjectState from "../../../components/Questions/TextFields/TextFieldForObjectState";

import SelectFieldForObjectState from "../../../components/Questions/TextFields/SelectFieldForObjectState";
import CheckConditions from "../../../components/Questions/CheckConditions";
import DisplayTextField from "../../../components/Questions/DisplayTextField";
import getArrayOfQuestionsAndNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfQuestionsAndNeededToSubmit";
import { Arr_GeneralInfo } from "../../../../arrays/SEF/Arr_GeneralInfo";
import { Consultant_Get_One_Nested_Prop_From_MongoDB } from "../../../../Consultants/api/Consultant_Get_One_Nested_Prop_From_MongoDB";
import { ConsultantuseAuth } from "../../../../Consultants/security/ConsultantUseAuth";
import { Consultant_Update_To_MongoDB_By_ID } from "../../../../Consultants/api/Consultant_Update_To_MongoDB_By_ID";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../../Consultants/api/Get_One_Choose_Fields_From_MongoDB";

function ViewSEFGeneralInfo() {
  const { id } = useParams();

  let logoutStudent;
  let logoutConsultant;
  if (window.location.href.indexOf("Student") > -1) {
    logoutStudent = StudentuseAuth().logoutStudent;
  } else {
    logoutConsultant = ConsultantuseAuth().logoutConsultant;
  }

  const [formInfo, setformInfo] = useState({});
  const [BasicInfo, setBasicInfo] = useState({});

  let Arr_AllSEFQuestions_GeneralInfo = Arr_GeneralInfo.filter((Obj) => {
    return Obj.Page === "GeneralInfo";
  });

  let AccomCheck =
    BasicInfo.ProgrammeTitle &&
    BasicInfo.ProgrammeVarient.toLowerCase().includes("accom");

  if (AccomCheck) {
    Arr_AllSEFQuestions_GeneralInfo = Arr_AllSEFQuestions_GeneralInfo.filter(
      (Obj) => {
        return Obj.SpecialCondition !== "NonAccom";
      }
    );
  }

  let Arr_QuestionsNeededToSubmit = Arr_AllSEFQuestions_GeneralInfo.filter(
    (Obj) => {
      return (
        CheckConditions(
          formInfo,
          Obj.onlyAppearIfValueIs,
          Obj.onlyAppearIfValueIsNot,
          Obj.withRegardsTo
        ) === true
      );
    }
  );

  let Arr_QuestionsNeededToSubmitAndIncomplete =
    Arr_QuestionsNeededToSubmit.filter((Obj) => {
      return (
        !formInfo[Obj.name] ||
        formInfo[Obj.name] == "" ||
        formInfo[Obj.name] == null ||
        formInfo[Obj.name] == undefined
      );
    });

  const isFormComplete = Arr_QuestionsNeededToSubmitAndIncomplete.length === 0;

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  const [SEFProgress, setSEFProgress] = useState({
    GeneralInfo: "",
  });

  const [obj_EC, setobj_EC] = useState({});
  const [obj_assignedEC, setobj_assignedEC] = useState({});
  const [StudentData, setStudentData] = useState({});

  useEffect(() => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "SEFGeneralInfo",
        setformInfo,
        logoutStudent
      );
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "SEFProgress",
        setSEFProgress,
        logoutStudent
      );
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "BasicInfo",
        setBasicInfo,
        logoutStudent
      );
    } else {
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "SEFProgress",
        setSEFProgress,
        logoutConsultant
      );
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "SEFGeneralInfo",
        setformInfo,
        logoutConsultant
      );

      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "BasicInfo",
        setBasicInfo,
        logoutConsultant
      );
      Get_One_Choose_Fields_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        { IPInfo: 1, SEFProgress: 1 },
        setStudentData,
        logoutConsultant
      );
    }
  }, []);

  useEffect(() => {
    //if the web page URL contains the string Student
    if (window.location.href.indexOf("Student") > -1) {
    } else {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        {},
        setobj_EC,
        logoutConsultant
      );
      if (StudentData && StudentData._id && StudentData._id.length === 24) {
        Get_One_Choose_Fields_From_MongoDB(
          "IP",
          "EC",
          StudentData.IPInfo?.EC_ID,
          { _id: 1, "MetaData.Agency_id": 1 },
          setobj_assignedEC,
          logoutConsultant
        );
      }
    }
  }, [StudentData]);

  let EC_Check_Permissions = false;
  if (
    localStorage.getItem("Consultant_id") === StudentData.IPInfo?.EC_ID ||
    (obj_EC.MetaData?.Admin === "Yes" &&
      obj_EC.MetaData?.Agency_id === obj_assignedEC.MetaData?.Agency_id)
  ) {
    EC_Check_Permissions = true;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleContact1NumberChange = (value) => {
    setformInfo((prevData) => ({
      ...prevData,
      Contact_1_Mobile_phone_number_inc_country_code: value,
    }));
  };

  const handleContact2NumberChange = (value) => {
    setformInfo((prevData) => ({
      ...prevData,
      Contact_2_Mobile_phone_number_inc_country_code: value,
    }));
  };

  const handleLocalAdultNumberChange = (value) => {
    setformInfo((prevData) => ({
      ...prevData,
      local_named_adult_for_non_res_number: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          SEFGeneralInfo: formInfo,
          "SEFProgress.GeneralInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          SEFGeneralInfo: formInfo,
          "SEFProgress.GeneralInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          SEFGeneralInfo: formInfo,
          "SEFProgress.GeneralInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          SEFGeneralInfo: formInfo,
          "SEFProgress.GeneralInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setSEFProgress({
      GeneralInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions &&
    (Object.keys(StudentData).length === 0 ||
      Object.keys(obj_EC).length === 0 ||
      Object.keys(obj_assignedEC).length === 0)
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Checking Access Permissions...</h1>
      </div>
    );
  } else if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Access Denied</h1>
      </div>
    );
  } else {
    return (
      <div className="view-basic-info-container">
        <h1>Summer Information</h1>
        {SEFProgress &&
        SEFProgress.GeneralInfo &&
        (SEFProgress.GeneralInfo === "Complete" ||
          SEFProgress.GeneralInfo === "Awaiting_Review") ? (
          <strong>
            If you need to make further changes, please contact InvestIN at
            info@investin.org or speak to your known contact
          </strong>
        ) : (
          ""
        )}

        <form className="view-basic-info-form">
          <h2>Parent/ Legal Guardian Information</h2>
          <p>
            Only parents/
            <strong> legal guardians </strong>
            (with parental responsibility) should complete the student enrolment
            form for each student attending an InvestIN summer experience.{" "}
            <br></br>
            <br></br>A legal guardian of a child is someone other than the
            child’s parents who has the legal authority to make decisions
            related to their care and wellbeing, on behalf of a child.{" "}
          </p>
          {/* Who is completing the form */}
          {Array.from({ length: 4 }, (_, i) => i).map((i) => (
            <>
              <DisplayTextField
                formInfo={formInfo}
                handleChange={handleChange}
                Object={Arr_GeneralInfo[i]}
              />
            </>
          ))}
          <h2>Emergency Contact Information</h2>
          <p>
            InvestIN requires two emergency contacts for each student attending
            a summer experience.
          </p>
          <p>
            Contact 1{" "}
            <b>
              <u>must</u>
            </b>{" "}
            be the student's parent or legal guardian with parental
            responsibility.
            <br></br>
            Contact 2 can be a{" "}
            <b>
              <u>trusted adult</u>
            </b>{" "}
            and does not have to be the student’s parent or legal guardian (e.g.
            another relative, family friend, or group leader or education
            consultant).{" "}
          </p>
          <p>
            At least one contact{" "}
            <b>
              <u>must</u>
            </b>{" "}
            speak English. In an emergency, we need to be able to contact an
            appropriate adult for the student quickly. Please note, that in an
            emergency, we may need to contact the parent or legal guardian
            directly.
          </p>
          <h3>Emergency Contact One (Parent/ Legal Guardian)</h3>
          {Array.from({ length: 5 }, (_, i) => i + 4).map((i) => (
            <>
              <DisplayTextField
                formInfo={formInfo}
                handleChange={handleChange}
                Object={Arr_GeneralInfo[i]}
              />
            </>
          ))}
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleContact1NumberChange}
            Object={Arr_GeneralInfo[9]}
          />
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_GeneralInfo[10]}
          />
          <h3>Emergency Contact Two (Trusted Adult)</h3>
          {Array.from({ length: 4 }, (_, i) => i + 11).map((i) => (
            <>
              <DisplayTextField
                formInfo={formInfo}
                handleChange={handleChange}
                Object={Arr_GeneralInfo[i]}
              />
            </>
          ))}
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleContact2NumberChange}
            Object={Arr_GeneralInfo[15]}
          />
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_GeneralInfo[16]}
          />
          {/* full name match check */}
          {/* {formInfo &&
        formInfo[Arr_GeneralInfo[13]] &&
        formInfo[Arr_GeneralInfo[6]] &&
        formInfo[Arr_GeneralInfo[13].name] ===
          formInfo[Arr_GeneralInfo[6].name] ? (
          <p>
            <b>
              <u>
                Please ensure that Contact 1 and Contact 2 are different people
                with different contact details.
              </u>
            </b>
          </p>
        ) : (
          <></>
        )} */}
          {/* Mobile match check */}
          {/* {formInfo &&
        formInfo[Arr_GeneralInfo[15]] &&
        formInfo[Arr_GeneralInfo[9]] &&
        formInfo[Arr_GeneralInfo[15].name] ===
          formInfo[Arr_GeneralInfo[9].name] ? (
          <p>
            <b>
              <u>
                Please ensure that Contact 1 and Contact 2 are different people
                with different mobile contact details.
              </u>
            </b>
          </p>
        ) : (
          <></>
        )} */}
          {/* email match check */}
          {/* {formInfo &&
        formInfo[Arr_GeneralInfo[16]] &&
        formInfo[Arr_GeneralInfo[10]] &&
        formInfo[Arr_GeneralInfo[16].name] ===
          formInfo[Arr_GeneralInfo[10].name] ? (
          <p>
            <b>
              <u>
                Please ensure that Contact 1 and Contact 2 are different people
                with different email contact details.
              </u>
            </b>
          </p>
        ) : (
          <></>
        )} */}
          {AccomCheck ? (
            <></>
          ) : (
            <>
              <h2>Accomodation Information</h2>
              {Array.from({ length: 8 }, (_, i) => i + 17).map((i) => (
                <>
                  <DisplayTextField
                    formInfo={formInfo}
                    handleChange={handleChange}
                    Object={Arr_GeneralInfo[i]}
                  />
                </>
              ))}
              {formInfo.staying_where_do_they_know === "Undecided" ? (
                <p>
                  Thank you for confirming you will book your child's
                  accommodation at a later date. InvestIN staff require the
                  address for each child's accommodation in the event of an
                  emergency. Please ensure you send this information to
                  info@investin.org at least 4 weeks before your child's summer
                  experience begins.
                </p>
              ) : (
                <></>
              )}
              {formInfo.will_student_be_18 === "Yes" ? (
                <p>
                  If yes, InvestIN strongly recommends that all students are
                  accompanied by an appropriate adult in their accommodation,
                  however, for students aged 18+, we understand that parents may
                  permit the student to stay unaccompanied. We do still ask for
                  a local named adult’s contact information that would be able
                  to support the student in an emergency.
                  <br></br>This can be a family member, family friend or other
                  appropriate adult over the age of 21. Please provide details
                  for who will be the responsible adult staying with the student
                  for the duration of their programme
                </p>
              ) : (
                <></>
              )}
              {formInfo.will_student_be_18 === "No" ? (
                <p>
                  If no, all students under the age of 18 are required to have
                  adult supervision in their accommodation. This can be a family
                  member, family friend or other appropriate adult over the age
                  of 21. Please provide details for who will be the responsible
                  adult staying with the student for the duration of their
                  programme
                </p>
              ) : (
                <></>
              )}
              {Array.from({ length: 5 }, (_, i) => i + 25).map((i) => (
                <>
                  <DisplayTextField
                    formInfo={formInfo}
                    handleChange={handleChange}
                    Object={Arr_GeneralInfo[i]}
                  />
                </>
              ))}

              <DisplayTextField
                formInfo={formInfo}
                handleChange={handleLocalAdultNumberChange}
                Object={Arr_GeneralInfo[30]}
              />
            </>
          )}
          {/* ------------------------- */}
          {window.location.href.indexOf("Student") > -1 ? (
            <SEFChangePage
              Page={"GeneralInfo"}
              PageButtonStatus={PageButtonStatus}
            />
          ) : (
            <></>
          )}
          {isFormComplete ? (
            <></>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>
                    You can save this page at any point. To submit this page,
                    please complete the following questions first:
                  </th>
                </tr>
              </thead>
              <tbody>
                {Arr_QuestionsNeededToSubmitAndIncomplete.map((Obj) => {
                  return (
                    <tr key={Obj.name}>
                      <td>{Obj.label}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          {/* full name match check */}
          {/* {formInfo &&
        formInfo[Arr_GeneralInfo[13]] &&
        formInfo[Arr_GeneralInfo[6]] &&
        formInfo[Arr_GeneralInfo[13].name] ===
          formInfo[Arr_GeneralInfo[6].name] ? (
          <p>
            <b>
              <u>
                Please ensure that Contact 1 and Contact 2 are different people
                with different contact details.
              </u>
            </b>
          </p>
        ) : (
          <></>
        )} */}
          {/* Mobile match check */}
          {/* {formInfo &&
        formInfo[Arr_GeneralInfo[15]] &&
        formInfo[Arr_GeneralInfo[9]] &&
        formInfo[Arr_GeneralInfo[15].name] ===
          formInfo[Arr_GeneralInfo[9].name] ? (
          <p>
            <b>
              <u>
                Please ensure that Contact 1 and Contact 2 are different people
                with different mobile contact details.
              </u>
            </b>
          </p>
        ) : (
          <></>
        )} */}
          {/* email match check */}
          {/* {formInfo[Arr_GeneralInfo[16].name]}
        {formInfo[Arr_GeneralInfo[10].name]}
        <br></br>
        {formInfo && formInfo[Arr_GeneralInfo[16]] ? "yesss" : "noo"}
        <br></br>
        {formInfo &&
        formInfo[Arr_GeneralInfo[16]] &&
        formInfo[Arr_GeneralInfo[10]] &&
        formInfo[Arr_GeneralInfo[16].name] ===
          formInfo[Arr_GeneralInfo[10].name]
          ? "yes"
          : "no"}
        {formInfo &&
        formInfo[Arr_GeneralInfo[16]] &&
        formInfo[Arr_GeneralInfo[10]] &&
        formInfo[Arr_GeneralInfo[16].name] ===
          formInfo[Arr_GeneralInfo[10].name] ? (
          <p>
            <b>
              <u>
                Please ensure that Contact 1 and Contact 2 are different people
                with different email contact details.
              </u>
            </b>
          </p>
        ) : (
          <></>
        )} */}{" "}
          <h3>
            Once this page is completed and you have completed every question,
            please click "Submit" to complete the page and send it for review by
            InvestIN. Otherwise, click "Save" if you are not ready to complete
            the page and wish to return later to make changes
          </h3>
          <div className="view-basic-info-buttons">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveProgress}
              disabled={
                status ||
                (SEFProgress &&
                  SEFProgress.GeneralInfo &&
                  (SEFProgress.GeneralInfo === "Complete" ||
                    SEFProgress.GeneralInfo === "Awaiting_Review")) ||
                Object.keys(formInfo).length === 0
              }
            >
              Save Progress
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              disabled={
                !isFormComplete ||
                status ||
                (SEFProgress &&
                  SEFProgress.GeneralInfo &&
                  (SEFProgress.GeneralInfo === "Complete" ||
                    SEFProgress.GeneralInfo === "Awaiting_Review")) ||
                // formInfo[Arr_AllSEFQuestions_GeneralInfo[13].name] ===
                //   formInfo[Arr_AllSEFQuestions_GeneralInfo[6].name] ||
                // formInfo[Arr_AllSEFQuestions_GeneralInfo[15].name] ===
                //   formInfo[Arr_AllSEFQuestions_GeneralInfo[9].name] ||
                // formInfo[Arr_AllSEFQuestions_GeneralInfo[16].name] ===
                //   formInfo[Arr_AllSEFQuestions_GeneralInfo[10].name] ||
                // (formInfo[Arr_AllSEFQuestions_GeneralInfo[17].name] ===
                //   "Contact one" &&
                //   formInfo[Arr_AllSEFQuestions_GeneralInfo[4].name] === "No") ||
                // (formInfo[Arr_AllSEFQuestions_GeneralInfo[17].name] ===
                //   "Contact two" &&
                //   formInfo[Arr_AllSEFQuestions_GeneralInfo[11].name] === "No") ||
                Object.keys(formInfo).length === 0
              }
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default ViewSEFGeneralInfo;
